import { addEvents } from '../events/add-events';

export default class Label {
    constructor(elem) {
        this.input = elem;
        this.setEvents();
        this.checkInput();
    }

    setEvents() {
        addEvents(this.input, ['keydown', 'keyup'], () => {
            this.checkInput(this.input);
        });
    }

    checkInput() {
        if (this.input.value.length > 0 || this.input.value !== this.input.defaultValue) {
            this.input.classList.add('is-active');
        } else {
            this.input.classList.remove('is-active');
        }
    }
}
